import { Component } from 'react';

import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { Button } from 'UIPackage/MainModule/components/Button';

import styles from './ErrorBoundary.module.scss';
import { saveFile } from '../common/saveFile';
import { IS_ESIA, LAW_INTERFACE, LOCAL_STORE, LOGIN } from '../constants/localStorageNames';
import { formatDate } from '../common/formatDate';
import { DATE_FORMAT_SYSTEM_FULL_FNS } from '../constants/dateFormats';

interface IErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<{}, IErrorBoundaryState> {
  static getDerivedStateFromError(error: Error): Partial<IErrorBoundaryState> {
    return { hasError: true, error };
  }

  constructor(props: {}) {
    super(props);
    this.onDownloadClick = this.onDownloadClick.bind(this);
  }

  state: IErrorBoundaryState = {
    hasError: false,
  };

  render() {
    const { hasError } = this.state;

    if (hasError) {
      return (
        <div className={styles.Wrapper}>
          <main className={styles.Content}>
            <Modal visible modalBodyClassName={styles.Modal}>
              <ModalHeader title="Ошибка" color="black" />
              <ModalBody size="content">Что-то пошло не так. Сообщите об ошибке в службу поддержки.</ModalBody>
              <ModalActions>
                <Button text="Скачать отладочную информацию" onClick={this.onDownloadClick} />
              </ModalActions>
            </Modal>
          </main>
        </div>
      );
    }
    const { children } = this.props;

    return children;
  }

  onDownloadClick() {
    const { error } = this.state;
    const timestamp = formatDate({ date: new Date(), dateFormat: `${DATE_FORMAT_SYSTEM_FULL_FNS} O` });
    const data = {
      timestamp,
      lawInterface: localStorage.getItem(LAW_INTERFACE),
      isESIA: sessionStorage.getItem(IS_ESIA),
      login: sessionStorage.getItem(LOGIN),
      localStorage: localStorage.getItem(LOCAL_STORE),
      errorName: error?.name,
      errorMessage: error?.message,
      stacktrace: error?.stack,
    };

    saveFile(new Blob([JSON.stringify(data)], { type: 'text/plain;charset=utf-8' }), `stacktrace ${timestamp}.zip`);
  }
}
